import L from 'leaflet';

export const FeatureNames = {
    BEPIJLING: 'Pijl',
    BEVOORRADINGSZONE: 'BevoorradingsZone'
};

export const VLAANDEREN_CENTER = [51.0132, 4.3554];
export const DEFAULT_ZOOM = 6;
export const MIN_ZOOM = 2;
export const DRAW_START_ZOOM = 16;
export const BOUNDS_PADDING = [35, 35];

export const RouteStyle = { color: '#FF0000' };
export const RouteEditStyle = { color: 'red' };
export const ZoneStyle = { color: 'blue', fillColor: 'blue' };

export const DrawRouteOptions = {
    tooltips: true,
    allowSelfIntersection: true,
    templineStyle: { color: 'orange' },
    hintlineStyle: { color: 'orange' },
    pathOptions: {
        color: 'orange',
        fillColor: 'orange'
    }
};

export const DrawZoneOptions = {
    tooltips: true,
    snapDistance: 10,
    allowSelfIntersection: true,
    templineStyle: { color: 'green' },
    hintlineStyle: { color: 'green' },
    pathOptions: {
        color: 'green',
        fillColor: 'green'
    }
};

export const legacyPointIcon = L.divIcon({
    className: 'fa fa-map-marker marker-x-large marker-red'
});

export const markerDivIcon = (size, color) => L.divIcon({
    className: `fa fa-map-marker marker-${size} marker-${color}`
});

export const OSM_ATTRIBUTION = '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>';
